<template>
  <div>
    <div class="page-loader-wrapper" v-if="isLoading">
        <div class="loader">
            <div>
            <img src="@/assets/images/Angel_Communities_Logo.svg" width="200" height="45" alt="PayAngel" loading="lazy"/>
            <p>Please wait...</p>
            </div>
        </div>
    </div>
    <FrontHeader :loggedInUserData="currentUser.data" />
      <div class="landing-page">
        <slot></slot>
      </div>
    <FrontFooter />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const FrontHeader = () => import('@/components/layouts/frontend/FrontHeader.vue');
const FrontFooter = () => import('@/components/layouts/frontend/FrontFooter.vue');
export default {
  name: "FrontendLayout",
  components: {
    FrontHeader,
    FrontFooter
  },
  computed: {
    homeLandingPageClasses() {
      let homeLandingPageClasses = [
        "home"
      ].includes(this.$route.name);
      return homeLandingPageClasses;
    },
    ...mapGetters(["isLoading","currentUser"])
  },
};
</script>
